import { ReactNode } from 'react';

export const ActionsSection = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col gap-2 empty:hidden">{children}</div>
);
